import { render } from "./answer_risk_assessment.html?vue&type=template&id=0105cb6a&external"
import script from "./answer_risk_assessment.js?vue&type=script&lang=js&external"
export * from "./answer_risk_assessment.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__